import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { CellClickedEvent, ColDef, GridReadyEvent, GridSizeChangedEvent } from 'ag-grid-community';


@Component({
    selector: 'app-admin-kpis',
    templateUrl: './kpis-admin.component.html',
    styleUrls: ['./kpis-admin.component.scss']
})
export class AdminKPIsComponent implements OnInit {
    @Input() kpi: any;
    @Input() id: any;
    @Input() dbData: any;
    gridClass = 'ag-theme-alpine-dark';

    labelArray: string[] = [];
    valuesArray: number[] = [];
    kpiName: string | undefined;
    kpiValue: number | undefined;
    silentUnitsTotal: number = 0;
    silentUnitsData: { id: number, esn: string, date: string }[] = [];
    watchlistTotal: number = 0;
    watchlistData: { id: number, name: string, status: string, lastMessage: string }[] = [];
    newInstalledUnitsTotal: number = 0;
    newInstalledUnitsData: { id: number, esn: string, installDate: string }[] = [];
    missedPayloadsTotal: number = 0;
    missedPayloadsData: { serialNumber: string, esn: string }[] = [];
    distributorsTotal: number = 0;
    avgConsumptionTotal: number = 0;

    public defaultColDef: ColDef = {
        sortable: false,
        filter: false,
    };


    watchlistColDefs: ColDef[] = [
        { field: 'name', sortable: false, filter: false, tooltipField: "Customer", headerName: "Customer" },
        { field: 'status', sortable: false, filter: false, tooltipField: "Status", headerName: "Status" },
        { field: 'lastMessage', sortable: false, filter: false, tooltipField: "Last Message", headerName: "Last Message", initialSort: 'asc' }
    ];

    silentUnitsColDefs: ColDef[] = [
        { field: 'esn', sortable: false, filter: false, tooltipField: "ESN", headerName: "ESN" },
        { field: 'date', sortable: false, filter: false, tooltipField: "Last Message", headerName: "Last Message" }
    ];

    newInstalledUnitsColDefs: ColDef[] = [
        { field: 'esn', sortable: false, filter: false, tooltipField: "ESN", headerName: "ESN" },
        { field: 'installDate', sortable: false, filter: false, tooltipField: "Installed", headerName: "Installed" }
    ];

    missedPayloadsColDefs: ColDef[] = [
        { field: 'serialNumber', sortable: false, filter: false, tooltipField: "Serial Number", headerName: "Serial Number" },
        { field: 'esn', sortable: false, filter: false, tooltipField: "ESN", headerName: "ESN" }
    ];

    constructor(private cdref: ChangeDetectorRef,
        private _router: Router,) { }

    ngOnInit() {
        if (localStorage.getItem('theme') == "light") {
            this.gridClass = 'ag-theme-alpine';
          } else {
            this.gridClass = 'ag-theme-alpine-dark';
          }
    }
    ngAfterViewInit() {
        for (let i = 0; i < this.dbData.length; i++) {
            this.kpiName = this.dbData[i].name;
            this.kpiValue = Math.round(this.dbData[i].total);
            if (this.dbData[i].type == 'none' && this.dbData[i].name == 'Distributors') {
                this.distributorsTotal = this.dbData[i].total;
            } else if (this.dbData[i].type == 'none' && this.dbData[i].name == 'Metered Tanks Avg Consumption') {
                this.avgConsumptionTotal = this.dbData[i].total === undefined ? 0 : this.dbData[i].total;
            } else if (this.dbData[i].type == 'grid') {
                this.processGridData(i);
            }
        }
        this.cdref.detectChanges();
    }

    onGridReady(params: GridReadyEvent) {
        params.api.sizeColumnsToFit();
        params.api.resetRowHeights();
        params.api.setDomLayout('autoHeight');
    }

    onGridSizeChanged(params: GridSizeChangedEvent) {
        params.api.sizeColumnsToFit();
    }

    onCellClicked($event: CellClickedEvent) {
        let url: string = "/dashboard/tanks/tank/" + $event.data.id
        this._router.navigate([url]);
    }

    onUnitCellClicked($event: CellClickedEvent) {
        let url: string = "/dashboard/units/unit/" + $event.data.id
        this._router.navigate([url]);
    }

    processGridData(index: number) {
        if (this.dbData[index].name.indexOf('Watchlist Tanks') > -1) {
            this.watchlistTotal = this.dbData[index].total;
            if (this.watchlistTotal > 0) {
                let valueSplit = this.dbData[index].value.split(' | ');
                for (let i = 0; i < valueSplit.length; i++) {
                    if (valueSplit[i].length > 1) {
                        let dataSplit = valueSplit[i].split(':');
                        let gridDataSplit = dataSplit[1].split(', ');
                        this.watchlistData.push({ 'id': dataSplit[0], 'name': gridDataSplit[0].trim(), 'status': gridDataSplit[1].replace(/([a-z](?=[A-Z]))/g, '$1 ').trim(), 'lastMessage': gridDataSplit[2] });
                    }
                }
            }
        }

        if (this.dbData[index].name.indexOf('New Silent SkyTrackers') > -1) {
            this.silentUnitsTotal = this.dbData[index].total;
            if (this.dbData[index].value != undefined) {
                let valueSplit = this.dbData[index].value.split(' | ');
                for (let i = 0; i < valueSplit.length; i++) {
                    if (valueSplit[i].length > 1) {
                        let dataSplit = valueSplit[i].split(':');
                        let gridDataSplit = dataSplit[1].split(', ');
                        this.silentUnitsData.push({ 'id': dataSplit[0], 'esn': gridDataSplit[0], 'date': gridDataSplit[1] });
                    }
                }
            }
        }

        if (this.dbData[index].name.indexOf('Newly Installed SkyTrackers') > -1) {
            this.newInstalledUnitsTotal = this.dbData[index].total;
            if (this.dbData[index].value != undefined) {
                let valueSplit = this.dbData[index].value.split(' | ');
                for (let i = 0; i < valueSplit.length; i++) {
                    if (valueSplit[i].length > 1) {
                        let dataSplit = valueSplit[i].split(':');
                        let gridDataSplit = dataSplit[1].split(', ');
                        this.newInstalledUnitsData.push({ 'id': dataSplit[0], 'esn': gridDataSplit[0], 'installDate': gridDataSplit[1] });
                    }
                }
            }
        }

        if (this.dbData[index].name.indexOf('Missed Payload SkyTrackers') > -1) {
            this.missedPayloadsTotal = this.dbData[index].total;
            if (this.dbData[index].value != undefined) {
                let valueSplit = this.dbData[index].value.split(' | ');
                for (let i = 0; i < valueSplit.length; i++) {
                    if (valueSplit[i].length > 1) {
                        let gridDataSplit = valueSplit[i].split(', ');
                        this.missedPayloadsData.push({ 'serialNumber': gridDataSplit[0], 'esn': gridDataSplit[1] });
                    }
                }
            }
        }
    }

}